import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

export function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
          <div className="text-center p-8 max-w-md">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">404 - Not Found</h1>
            <p className="text-gray-600 mb-8">
              Sorry, we couldn't find what you were looking for.
            </p>
            <div className="space-x-4">
              <Button
                onClick={() => navigate(-1)}
                variant="outline"
              >
                Go Back
              </Button>
              <Button
                onClick={() => navigate('/jobs')}
              >
                View All Jobs
              </Button>
            </div>
          </div>
        </div>
      );
    }

    if (error.status === 401) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
          <div className="text-center p-8 max-w-md">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">401 - Unauthorized</h1>
            <p className="text-gray-600 mb-8">
              You need to be logged in to access this page.
            </p>
            <Button
              onClick={() => navigate('/auth/login')}
            >
              Log In
            </Button>
          </div>
        </div>
      );
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center p-8 max-w-md">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Oops!</h1>
        <p className="text-gray-600 mb-8">
          Something went wrong. Please try again later.
        </p>
        <div className="space-x-4">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
          >
            Go Back
          </Button>
          <Button
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </Button>
        </div>
      </div>
    </div>
  );
} 